module.exports = __webpack_public_path__ + "static/pokoj-nr1-photo09-d602dcb5c09421ec9035c7b41613379a.jpg";